import React from 'react';
import PropTypes from 'prop-types';
import { Select } from '@glu/form-components';
import locale from '@glu/locale';

const FontWeight = ({ name, labelText }) => (
  <Select
    name={name}
    labelText={labelText}
    options={[
      { label: locale.get('branding.light'), value: '300' },
      { label: locale.get('branding.regular'), value: '400' },
      { label: locale.get('branding.medium'), value: '500' },
      { label: locale.get('branding.bold'), value: '700' }
    ]}
  />
);

FontWeight.propTypes = {
  name: PropTypes.string.isRequired,
  labelText: PropTypes.string.isRequired
};


export default FontWeight;
